import { Component, Input, OnChanges, Output, SimpleChanges, inject } from '@angular/core';
import { DelayedBehaviorSubject } from '@forgerock/backstage-ui-core';
import { Observable } from 'rxjs';
import { AppSearchParamsInt } from '../../model/app-search-params';
import { SearchParamsMapperService } from '../search-params-mapper.service';

@Component({
  selector: 'app-search-params-container',
  templateUrl: './search-params-container.component.html',
  styleUrls: [ './search-params-container.component.scss' ],
  standalone: true
})
export class SearchParamsContainerComponent implements OnChanges {
  private mapper = inject(SearchParamsMapperService);


  @Input()
  params: AppSearchParamsInt;

  private readonly _paramsChange = new DelayedBehaviorSubject<AppSearchParamsInt>();

  @Output()
  readonly paramsChange: Observable<AppSearchParamsInt> = this._paramsChange.asObservable();

  setParams(params: Partial<AppSearchParamsInt>): AppSearchParamsInt {
    const mergedParams = { ...this.params, page: 1, ...params };
    this.params = mergedParams;
    this._paramsChange.next(mergedParams);
    return mergedParams;
  }

  async resetParams(): Promise<AppSearchParamsInt> {
    const emptyParams = await this.mapper.emptySearchParamsInt();
    const { tab, query } = this.params ?? {};
    return this.setParams({ ...emptyParams, tab, query });
  }

  async ngOnChanges({ params }: SimpleChanges) {
    if (params.currentValue) {
      this._paramsChange.next(params.currentValue);
    }
  }

}
